import { StateManager } from 'AppReact';

export default StateManager([
  {
    name: 'html',
    isRemote: true,
    isSingleton: true,
    defaultValue: [],
    create: (html) => { return `/api/data` }
  },
])
